import type { AuthenticationOptionsT } from "models/models";
import apiRequest from "../utils/ApiRequest/apiRequest";
import type { ApiResponseObjectT } from "./models";

const GetSubUserDetailsApiRequest = async () => {
  try {
    const response = await apiRequest("SubUsers", "GetSubUserDetails");
    return response;
  } catch (error) {
    console.error("Error fetching sub-user details:", error);
    throw error;
  }
};

const GetOrganizationLogoApiRequest = async (bucket: string) => {
  try {
    const response = await apiRequest("SubUsers", "GetOrganizationLogo", {
      bucket,
    });
    return response;
  } catch (error) {
    console.error("Error fetching organization logo:", error);
    throw error;
  }
};

const GetOrganizationAuthenticationOptionsApiRequest = async (
  bucket: string
): Promise<
  ApiResponseObjectT<GetOrganizationAuthenticationOptionsApiResponseT>
> => {
  const response = await apiRequest(
    "SubUsers",
    "GetOrganizationAuthenticationOptions",
    { bucket }
  );

  return response;
};

const GetOrganizationInvitationLinkApiRequest = async (bucket: string) => {
  try {
    const response = await apiRequest(
      "SubUsers",
      "GetOrganizationInvitationLink",
      {
        bucket,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching organization invitation link:", error);
    throw error;
  }
};

export type GetOrganizationAuthenticationOptionsApiResponseT = {
  AuthenticationOptions: AuthenticationOptionsT;
  LoginSource: "google" | "microsoft" | "";
  TopUserPageLink: string;
  OrganizationName: string;
};

export {
  GetSubUserDetailsApiRequest,
  GetOrganizationLogoApiRequest,
  GetOrganizationAuthenticationOptionsApiRequest,
  GetOrganizationInvitationLinkApiRequest,
};
